import { useContentSelector } from '@wajeez-web/stores/content';
import PreviewAudioComponent from './PreviewAudioComponent';
import { Collapse } from 'antd';
import { Server } from '@wajeez-web/core/api-base';
import { Button } from '@wajeez-web/components/ui';
import { BiEditAlt } from 'react-icons/bi';
import { HasPermission } from '@wajeez-web/components/helpers';
import { convertMarkdownToHtml } from '@wajeez-web/core/utils';
import { ListLoader } from '@wajeez-web/components/list-builder';

export interface PreviewCollectionProps {
  getContentTexts: (id: string) => Promise<void>;
  getContentAudios: (id: string) => Promise<void>;
  onClose: () => void;
  isLoading: boolean;
  modalDetails: Server.ContentEntityTypeDetailedOutput | null;
  setContentFormState: (state: { show: boolean; id?: string }) => void;
  contentFormState: { show: boolean; id?: string };
  onEdit: (id: string) => void;
  onSubmit: (data: Server.CreateContentEntityByTypeIdV2Input) => Promise<void>;
}
const { Panel } = Collapse;

const PreviewCollection = ({
  modalDetails,
  isLoading,
  contentFormState,
  getContentAudios,
  getContentTexts,
  setContentFormState,
  onClose,
  onSubmit,
  onEdit,
}: PreviewCollectionProps) => {
  const { previewStatus, previewData } = useContentSelector(
    (state) => state.contentEntity
  );

  return (
    <div className="space-y-4">
      {previewStatus === 'loading' ? (
        <ListLoader loading={previewStatus === 'loading'} />
      ) : (
        previewData.map((item) => (
          <Collapse key={item.id} collapsible="header" defaultActiveKey={['1']}>
            <Panel
              className="text-[16px]"
              header={item.title}
              key="1"
              extra={
                <Button
                  disabled={HasPermission('27.2') ? false : true}
                  type="text"
                  shape="circle"
                  color="textSecondary"
                  bg="gray-500/10"
                  Icon={BiEditAlt}
                  onClick={() => onEdit(item.id || '')}
                />
              }
            >
              <div className="space-y-2">
                {
                  <div
                    dangerouslySetInnerHTML={{
                      __html: convertMarkdownToHtml(item.text) ?? '',
                    }}
                  />
                }

                {item.audioReference && (
                  <PreviewAudioComponent
                    key={item.id}
                    value={item.audioReference}
                    fileName={item.title}
                  />
                )}
              </div>
            </Panel>
          </Collapse>
        ))
      )}
    </div>
  );
};

export default PreviewCollection;
